import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "./Seo";
import "./App.css";
import "./PartnerApply.css";
import Navbar from "./Navbar";
import Footer from "./Footer";

const languages = [
  { code: "en", name: "English", nativeName: "English" },
  { code: "hi", name: "Hindi", nativeName: "हिन्दी" },
  { code: "ta", name: "Tamil", nativeName: "தமிழ்" },
  { code: "ml", name: "Malayalam", nativeName: "മലയാളം" },
  { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" },
  { code: "bn", name: "Bengali", nativeName: "বাংলা" },
];

const ui = {
  en: {
    title: "Begin your journey with Baatcheet",
    subtitle: "Select your language to proceed",
    confirm: "Confirm",
  },
  hi: {
    title: "Baatcheet के साथ अपनी यात्रा शुरू करें",
    subtitle: "आगे बढ़ने के लिए अपनी भाषा चुनें",
    confirm: "पुष्टि करें",
  },
  ta: {
    title: "Baatcheet உடன் உங்கள் பயணத்தை தொடங்குங்கள்",
    subtitle: "தொடர உங்கள் மொழியை தேர்ந்தெடுக்கவும்",
    confirm: "உறுதிப்படுத்து",
  },
  ml: {
    title: "Baatcheet-ൽ നിങ്ങളുടെ യാത്ര ആരംഭിക്കൂ",
    subtitle: "തുടരാൻ ഭാഷ തിരഞ്ഞെടുക്കൂ",
    confirm: "സ്ഥിരീകരിക്കുക",
  },
  kn: {
    title: "Baatcheet ಜೊತೆ ನಿಮ್ಮ ಪ್ರಯಾಣ ಪ್ರಾರಂಭಿಸಿ",
    subtitle: "ಮುಂದುವರೆಯಲು ನಿಮ್ಮ ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ",
    confirm: "ದೃಢೀಕರಿಸಿ",
  },
  bn: {
    title: "Baatcheet-এর সাথে আপনার যাত্রা শুরু করুন",
    subtitle: "এগিয়ে যেতে আপনার ভাষা বেছে নিন",
    confirm: "নিশ্চিত করুন",
  },
};

function renderTitle(title) {
  const parts = title.split("Baatcheet");
  if (parts.length === 1) return <span>{title}</span>;
  return (
    <>
      {parts[0]}
      <strong className="pa-brand">Baatcheet</strong>
      {parts[1]}
    </>
  );
}

function PartnerApply() {
  const [selected, setSelected] = useState("en");
  const navigate = useNavigate();

  const strings = ui[selected];

  return (
    <>
      <Seo
        title="Apply to Become a Baatcheet Partner | Baatcheet"
        description="Choose your language and start your Baatcheet Partner application — verified onboarding in minutes."
        path="/partner-apply"
      />
      <div className="bg" />
      <div className="confetti">
        <i className="dot s1" />
        <i className="cbar s2" />
        <i className="dot s3" />
        <i className="cbar s4" />
        <i className="dot s5" />
        <i className="dot s6" />
        <i className="cbar s7" />
        <i className="dot s8" />
        <i className="cbar s9" />
        <i className="dot s10" />
      </div>

      <Navbar />

      <main className="pa-main">
        <div className="pa-floating-dots" aria-hidden="true">
          <span className="pa-dot pa-dot-1" />
          <span className="pa-dot pa-dot-2" />
          <span className="pa-dot pa-dot-3" />
          <span className="pa-dot pa-dot-4" />
          <span className="pa-dot pa-dot-5" />
        </div>

        <div className="pa-card shell">
          <div className="pa-card-logo">
            <a className="brand pa-brand-hero" href="/">
              <span className="tile">
                <img src="/logo.webp" alt="Baatcheet" />
              </span>
              <span className="wm">
                <span className="en">Baat</span>
                <span className="hi">चीत</span>
              </span>
            </a>
          </div>

          <h1 className="pa-title">{renderTitle(strings.title)}</h1>
          <p className="pa-subtitle">{strings.subtitle}</p>

          <div className="pa-lang-grid">
            {languages.map((lang) => (
              <button
                key={lang.code}
                className={`pa-lang-card ${selected === lang.code ? "pa-lang-selected" : ""}`}
                onClick={() => setSelected(lang.code)}
              >
                <span className="pa-lang-main">{lang.name}</span>
                <span className="pa-lang-native">{lang.nativeName}</span>
              </button>
            ))}
          </div>

          <button
            className="pa-confirm-btn"
            onClick={() => navigate(`/partner-otp?lang=${selected}`)}
          >
            {strings.confirm}
          </button>
        </div>

        <div className="pa-illus-wrap">
          <img
            src="/lang-illus.webp"
            alt="Baatcheet community"
            className="pa-illus"
          />
        </div>
      </main>

      <Footer />
    </>
  );
}

export default PartnerApply;
